export const COLUMN_NAMES = {
  BACKLOG: "Backlog",
  READY: "Ready",
  DOING: "Doing",
  REVIEW: "Review",
  BLOCKED: "Blocked",
  DONE: "Done",
};